module.exports = __webpack_public_path__ + "img/6-424-424.3f91ab8d.png";